import type { DinhMucCoDinhWizardStep } from '@/types/dinh-muc-co-dinh';

export const DINH_MUC_CO_DINH_WIZARD_STEPS: {
  id: DinhMucCoDinhWizardStep;
  label: string;
  index: number;
  iconClass: string;
}[] = [
  {
    id: 'meta',
    label: '1. Thông tin định mức',
    index: 1,
    iconClass: 'fas fa-file-alt',
  },
  {
    id: 'dmVatTu',
    label: '2. Vật tư định mức',
    index: 2,
    iconClass: 'fas fa-boxes',
  },
];

export const DINH_MUC_CO_DINH_WIZARD_STEP_META: DinhMucCoDinhWizardStep =
  'meta';
export const DINH_MUC_CO_DINH_WIZARD_STEP_DM_VAT_TU: DinhMucCoDinhWizardStep =
  'dmVatTu';
